###
# Подписки на услуги
###
App.ServiceSubscription = DS.Model.extend
  subscription_start : DS.attr 'date'
  subscription_end   : DS.attr 'date'

  organization  : DS.belongsTo 'organization', async: true
  service       : DS.belongsTo 'service', async: true
  restaurant    : DS.belongsTo 'restaurant', async: true

  switchTariff: (targetTariff) ->
    data = service_subscription:
      service_id:      targetTariff.get('id')
      organization_id: @get('organization.id')

    @nonRESTAction('PUT', 'switch', data)